//import Vue from "vue";

import axios from "axios";

const ENQUIRY_STORE_OBJ = "stefab_enquiries";

const client = axios.create({
  baseURL: "https://super.momentum-software.com:30025/api/",
  json: true
});

export default {
  async execute(method, resource, data) {
    try {
      // inject the accessToken for each request
      let objResponse = await client({
        method,
        url: resource,
        data,
        headers: {}
      });
      return objResponse.data;
    } catch (error) {
      console.log("err in catch", error.response.data);
      return error.response.data;
    }
  },

  async login(data) {

    if(data.username == "varun" && data.password == "password"){

      return  {
          blnOk: true, 
          objUser: {
            username: "varun",
            name: "Varun Bhandari",
            email: "software.momentum@gmail.com",
            phone: "9891166747",
            role: "Administrator"
          }
      };

    }else {
      
      return  {
        blnOk: false, 
        msg: "Incorrect username, password!"
      };
    }

    //real api
    //return await this.execute("post", `/authenticate`, { objModel: data });
  },

  async processOfflineEquiries(){

    var arrEnquiries =  await this.getOfflineEnquiries();

    if(arrEnquiries.length){  

      console.log("starting offline enquiry processing");
      for(var objEnquiry of arrEnquiries){

          console.log("processing enquiry", objEnquiry);
          let objResponse = await this.postEnquiry(objEnquiry);

          if(objResponse.blnOk){
              arrEnquiries.splice(0, 1);  
              localStorage.setItem(ENQUIRY_STORE_OBJ, JSON.stringify(arrEnquiries));
              console.log("processed enquiry");
          }
      }

      return arrEnquiries.length;
    }


  },

  async getOfflineEnquiriesCount() {
        
    var arrEnquiries = [];
    if(localStorage.getItem(ENQUIRY_STORE_OBJ)){
      arrEnquiries = JSON.parse(localStorage.getItem(ENQUIRY_STORE_OBJ));
    }
     return arrEnquiries.length;
  },
   
  async getOfflineEnquiries() {
        
    var arrEnquiries = [];
    if(localStorage.getItem(ENQUIRY_STORE_OBJ)){
      arrEnquiries = JSON.parse(localStorage.getItem(ENQUIRY_STORE_OBJ));
    }
    console.log("Offline Enquiries are ", arrEnquiries);
    return arrEnquiries;
  },

  async saveEnquiry(data) {
        
    var arrEnquiries = [];
    if(localStorage.getItem(ENQUIRY_STORE_OBJ)){
      arrEnquiries = JSON.parse(localStorage.getItem(ENQUIRY_STORE_OBJ));
    }
    arrEnquiries.push(data);
    localStorage.setItem(ENQUIRY_STORE_OBJ, JSON.stringify(arrEnquiries));

    return  {
      blnOk: true
    };
  },

  async processEnquiry(connectionStatus, data) {
    
    //offline  
    if(!connectionStatus){

      console.log("saving enquiry", data);
      return await this.saveEnquiry(data);  

    } else { //online

       console.log("posting", data);
 
       //real api
       return await this.postEnquiry(data);
    }

  },

  async postEnquiry(data) {
    
    return  {
      blnOk: true, 
      id: 123,
      data
    };

    //return await this.execute("post", `/enquiry`, { objModel: data });
  },

  async getEnquiryDefaults() {
    return await this.execute("get", "enquiry-defaults/", {});
  },
  
 
};
